import { InputValidators, InputValue } from '@csp/csp-common-form';

export type Credentials = {
  username: Readonly<InputValue>;
  password: Readonly<InputValue>;
};

const email: InputValue = {
  value: '',
  validators: [InputValidators.required, InputValidators.email],
  errors: [],
};

const required: InputValue = {
  value: '',
  validators: [InputValidators.required],
  errors: [],
};

const password: InputValue = {
  value: '',
  validators: [
    InputValidators.required,
    InputValidators.minLength(8),
    InputValidators.containsUpperCase(),
    InputValidators.containsLowerCase(),
    InputValidators.containsNumber(),
    InputValidators.containsSpecialCharacter(),
  ],
  errors: [],
};

type InputValues = Readonly<{
  email: Readonly<InputValue>;
  required: Readonly<InputValue>;
  password: Readonly<InputValue>;
}>;

export const CredentialForm: InputValues = {
  email,
  required,
  password,
};
